import { useRef, useState } from 'react';
import { Button } from '@ai-tutor/ui';
import { LessonOptionsMenu } from './LessonOptionsMenu';
import { LessonTabs } from './LessonTabs';
import { MoreHorizontal } from 'lucide-react';
import type { LessonProgress, LessonTab } from '@/types/lesson';

interface LessonHeaderProps {
  progress: LessonProgress;
  activeTab: LessonTab;
  onTabChange: (tab: LessonTab) => void;
  hasNewContent?: boolean;
  lessonId?: string;
}

export function LessonHeader({
  progress,
  activeTab,
  onTabChange,
  hasNewContent = false,
  lessonId,
}: LessonHeaderProps) {
  const [showOptionsMenu, setShowOptionsMenu] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  return (
    <div className='border-b border-border'>
      <div className='flex items-center'>
        {/* Tabs - left side */}
        <div className='flex-1'>
          <LessonTabs
            activeTab={activeTab}
            onTabChange={onTabChange}
            progress={progress}
            hasNewContent={hasNewContent}
          />
        </div>

        {/* Options menu - right side. Now fetches real Coverage/status from
            GET /lessons/{id}/progress instead of consuming mock LessonProgress. */}
        <div className='relative ml-4 mr-3 flex items-center'>
          <Button
            ref={triggerRef}
            variant='ghost'
            size='sm'
            onClick={() => setShowOptionsMenu(open => !open)}
            aria-label='Progress and options'
            aria-expanded={showOptionsMenu}
            className='h-8 w-8 p-0 text-muted-foreground hover:bg-muted hover:text-foreground'
          >
            <MoreHorizontal className='h-4 w-4' />
          </Button>

          {showOptionsMenu && (
            <LessonOptionsMenu
              lessonId={lessonId}
              onClose={() => setShowOptionsMenu(false)}
              triggerRef={triggerRef}
            />
          )}
        </div>
      </div>
    </div>
  );
}
